<div *ngIf="banner" [innerHtml]="banner.content | safeHtml" [class.hide]="!showBanner">
</div>
<div class="timer-banner-wrapper timer-banners--expired slideInUp" [class.hide]="!expired">
  <div class="timer-banner--innerWrap">
    <div class="timer-banner--header">
      <div class="container-fluid">
        <div class="timer-banner--header-innerwrap">
          <h1>&nbsp;</h1>
        </div>

        <div class="timer-banner--closeicon"><i class="icon-close-simplified"></i></div>
      </div>
    </div>

    <div class="timer-banner--body">
      <div class="container-fluid">
        <div class="timer-banner-expired-content">
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="banner" class="timer-banner-wrapper timer-banners--minimize slideInUp" [class.hide]="!minimised">
  <div class="container-fluid">
    <div class="timer-banners--mini-wrap">
      <div class="timer-banners--mini-body" (click)="cancelBanner()">
        <h1>{{timeLeft}}</h1>
        <div class="timer-bannner--mini-right-content">
          <p></p>
          <span class="terms-link">{{'timerBanner.bonusTermsConditions' | translate}}</span>
        </div>
      </div>
      <div class="timer-banners--mini-footer hidden-xs hidden-sm" (click)="cancelBanner()">
        <p class="claim-offer">{{'timerBanner.claimOffer' | translate}}</p>
      </div>
    </div>
  </div>
</div>